import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { v4 } from 'uuid';
import { isSupportFilter } from '../../../helpers/common';
import { propBool, propChildren, propStr, } from '../../../helpers/custom-prop-types';
class BlurText extends Component {
    constructor(props) {
        super(props);
        this.textId = v4();
    }
    render() {
        const { children, className, component: WrapComponent, isBlur, isCenter, isMaterialIcon, svgClassName, } = this.props;
        if (!isBlur) {
            return _jsx(WrapComponent, Object.assign({ className: className }, { children: children }));
        }
        const setClass = `blur-text ${isSupportFilter ? '' : 'not-support-filter'}`;
        if (isSupportFilter) {
            return (_jsx(WrapComponent, Object.assign({ className: `${className} ${setClass}` }, { children: children })));
        }
        return (_jsx(WrapComponent, Object.assign({ className: `${className} ${setClass}` }, { children: _jsxs("svg", Object.assign({ className: `svg-blur-text ${svgClassName}` }, { children: [_jsx("defs", { children: _jsx("filter", Object.assign({ height: '100%', id: this.textId, width: '100%', x: '0', y: '0' }, { children: _jsx("feGaussianBlur", { in: 'SourceGraphic', stdDeviation: '6' }) })) }), isCenter ? (_jsx("text", Object.assign({ dominantBaseline: 'central', filter: `url(#${this.textId})`, fontFamily: isMaterialIcon ? 'Material Icons' : undefined, textAnchor: 'middle', x: '50%', y: '50%' }, { children: children }))) : (_jsx("text", Object.assign({ filter: `url(#${this.textId})`, fontFamily: isMaterialIcon ? 'Material Icons' : undefined, x: '0', y: '1em' }, { children: children })))] })) })));
    }
}
BlurText.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    component: propStr().isRequired,
    isBlur: propBool(),
    isCenter: propBool(),
    isMaterialIcon: propBool(),
    svgClassName: propStr(),
};
BlurText.defaultProps = {
    className: '',
    isBlur: true,
    isCenter: false,
    isMaterialIcon: false,
    svgClassName: '',
};
export default BlurText;
